const awsExports = {
  aws_project_region: "ap-south-1",
  aws_cognito_region: "ap-south-1",
  aws_user_pools_id: "ap-south-1_DUil3CokS",
  aws_user_pools_web_client_id: "20qduhbkr9t25k1n2q9b1jfo93",
  oauth: {
    domain: "360customizer.auth.us-east-1.amazoncognito.com",
    scope: ["email", "openid", "profile"],
    redirectSignIn: "http://localhost:3000/",
    redirectSignOut: "http://localhost:3000/",
    responseType: "code",
  },
};

export default awsExports;
